/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {enableProdMode} from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import {environment} from './environments/environment';
import {browserTracingIntegration} from '@sentry/angular-ivy';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

/**
 * Sentry can be hosted by different providers.
 * Each provider has its own DSN.
 */
enum SentryDsn {
  /** Hosted by Regulus Team on their own server. No fee. */
  RegulusTeam = 'https://7ab03ae0d45b8506b4474137e8f614d8@sentry2.regulus.team/18',

  /** Hosted by Sentry.io. */
  BrainkeySentryIo = 'https://1bb8b72880d84b9ba7c422a7dd679b61@o193735.ingest.sentry.io/6127838',
}

Sentry.init({
  dsn: SentryDsn.BrainkeySentryIo,
  integrations: [
    browserTracingIntegration(),
  ],
  tracePropagationTargets: ['https://www.brainkey.ai/api', 'https://brainkey.ai/api', 'https://staging.brainkey.ai/api', 'https://dev.brainkey.ai/api'],
  ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured'],
  tracesSampleRate: 0.2,
});

if (environment.production) {
  enableProdMode();
}


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
